export const LOGGED_IN_USER:string = 'LOGGED_IN_USER';

export const TOKENS:string = 'TOKENS';

export const TOKEN_BEARER:string = 'TOKEN_BEARER';
export const TOKEN_EXPIRATION: string = 'TOKEN_EXPIRATION';

export const LANGUAGE:string = "axessLanguage";

export const MARKET = 'AXESS_MARKET';
